module.exports = __webpack_public_path__ + "static/img/yiqing.52e73861.png";